/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
import { DMNNM } from '../configs/ops';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class ExchangePremierLeagueSEO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }



    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login ">


                <Loginb2cHeader history={this.props.history}></Loginb2cHeader>
                {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
                <div className='login-mar-top100 '>
                    <section className='sportbook-livecasino'>
                        <div>
                            <img alt="Exchange Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchanges-banner.jpg"} />

                        </div>
                        <div>
                            <div className="">
                                <div className='seo-content-page'>
                                    <h2 align="center">{DMNNM}: The Best Place For Betting In The Premier League</h2>
                                    <p>
                                        The Premier League matches are famous all over the world. Entertain and fun
                                        to watch, they are watched by fans who all have their favorite teams and
                                        players. Thus, it is hardly surprising that    <strong>Premier League betting </strong>is gaining so much popularity among
                                        the fans. Sports fans just can't help considering the    <strong>Premier League betting odds </strong>and betting according to as
                                        they are committed to their favorite players and game. However, it is
                                        really important one should go for only the    <strong>best online betting id </strong>for the purpose as it is best to do
                                        the <strong>Premier League betting online in India</strong>. That's because
                                        you get to <strong>bet fair Premier League </strong>online, whereas that
                                        may not be the case offline.
                                    </p>
                                    <p>
                                        <strong>Reasons For Betting</strong>
                                    </p>
                                    <p>
                                        There may be two main reasons for going for    <strong>Premier League betting </strong>- either one wants to show one's
                                        love and dedication to a particular play or team, or one is just too sure
                                        that a particular team will win even against the worst    <strong>Premier League betting odds,</strong>and one wants to make money
                                        out of this idea. The advantages of <strong>premierleague betting </strong>
                                        are, however, many - it can be a good way of making a game more fun and
                                        fill one with a sense of adventure. It can make your team's victory a lot
                                        more special with winnings. It can also be a good way of making a bit of
                                        extra money - though that should not be one's key motivation.
                                    </p>
                                    <p>
                                        It's best to think of your wins only against bonuses and, rather, to place
                                        bets just for the fun of it. Doing so - that is, not expecting a win every
                                        single time will help you keep things in perspective and not bet and thus
                                        lose too much, while wins will be extra delightful for being unexpected.
                                    </p>
                                    <p>
                                        <strong>{DMNNM} is the Best Place To Bet Online</strong>
                                    </p>
                                    <p>
                                        {DMNNM} is the best place for<strong>Premier League betting online in India</strong>. It's the    <strong> best online betting id </strong>you will ever find. Ours is the
                                        best available <strong>Premier League betting odds </strong>for every
                                        single game as we know how to make the bets irresistible. And we offer only
                                        opportunities for <strong>bet fair Premier League</strong>. All your
                                        payments to us will be through safe routes as it is really easy to withdraw
                                        your winnings.
                                    </p>
                                    <p>
                                        Anyone that is an adult and of sound mind can easily make bets through us.
                                        Moreover, our platform allows you to place your bets in Indian money.
                                        However, it is important to note betting can become addictive, and if you
                                        think that might become the case with you, you should avoid betting with us
                                        altogether.
                                    </p>
                                    <p>
                                        As the best website for    <strong>Premier League betting online in India</strong>, we know how to
                                        create an excellent customer experience for our customers. You will find
                                        that it is really easy to place your bets through us, and you can also
                                        check your ongoing bets anytime. Once you have tried it, you will find that
                                        it is for good reasons that our clients call ours the<strong>best online betting id</strong> - not only for    <strong>bet fair Premier League</strong> but also for other games and
                                        sports.
                                    </p>

                                </div>
                            </div>

                        </div>
                    </section>
                </div>


                <Loginb2cFooter history={this.props.history}></Loginb2cFooter>


            </div>)

    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExchangePremierLeagueSEO);